import { Guid } from '../../../../model/guid';
import {
  CourseCompletionStatus,
  QuizStatus,
  TrackingClient,
  TrackingData,
  TrackingDataVersion,
} from '../trackingClient';
import { TrackingClientTrackingIdWrapper } from '../TrackingClientTrackingIdWrapper';
import { List, Set } from 'immutable';

export class ScormClientCompressionWrapper implements TrackingClient {
  _getParent: (childId: Guid) => Guid | null;
  _getChildren: (
    parentId: Guid,
    finishedItemIds?: Set<string>,
    trackingDataVersion?: TrackingDataVersion
  ) => List<Guid> | null;
  _client: TrackingClientTrackingIdWrapper;

  constructor(
    getParent: (childId: Guid) => Guid | null,
    getChildren: (
      parentId: Guid,
      finishedItemIds?: Set<string>,
      trackingDataVersion?: TrackingDataVersion
    ) => List<Guid> | null,
    trackingClient: TrackingClientTrackingIdWrapper
  ) {
    this._getParent = getParent;
    this._getChildren = getChildren;
    this._client = trackingClient;
  }

  setCompletionStatus(status: CourseCompletionStatus): Promise<void> {
    return this._client.setCompletionStatus(status);
  }

  async setTrackingData({ widgetTrackingData, finishedItems }: TrackingData): Promise<void> {
    const optimalizedFinishedItems = finishedItems.reduce(
      (finishedItems: Set<Guid>, finishedItem: Guid) => this.replaceWithParentIfComplete(finishedItem, finishedItems),
      finishedItems
    );
    return this._client.setTrackingData({
      widgetTrackingData,
      finishedItems: optimalizedFinishedItems,
      version: TrackingDataVersion.v2,
    });
  }

  async setQuizStatus(quizStatus: QuizStatus): Promise<void> {
    return this._client.setQuizStatus(quizStatus);
  }

  private replaceWithParentIfComplete = (addedId: Guid, existingItemIds: Set<Guid>): Set<Guid> => {
    const parent = this._getParent(addedId);
    if (parent) {
      const children = this._getChildren(parent);
      if (children) {
        if (existingItemIds.isSuperset(children)) {
          return existingItemIds.subtract(children).concat([parent]);
        }
      }
    }
    return existingItemIds;
  };
}
